import { render, staticRenderFns } from "./ListClientsPage.vue?vue&type=template&id=386e34e7"
import script from "./ListClientsPage.vue?vue&type=script&lang=js"
export * from "./ListClientsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports